import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { IShift } from 'src/app/modules/core/interfaces';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { IResponseLapExtractionModal } from 'src/app/modules/widget/interfaces/production-type-truck-point';
import { ProdByExtractionPointChartComponent } from '../../production-by-street/prod-by-extraction-point-chart/prod-by-extraction-point-chart.component';

@Component({
  selector: 'app-prod-by-typetruck-chart',
  templateUrl: './prod-by-typetruck-chart.component.html',
})
export class ProdByTypetruckChartComponent extends ProdByExtractionPointChartComponent implements OnChanges {
  @Input() public loopByTypeTruck: IResponseLapExtractionModal;
  public hasData = true;
  constructor(
    protected langService: LanguageService,
    protected parameterService: ParameterHandlerService,
    protected googleAnalyticsService: GoogleAnalyticsService,
  ) {
    super(langService, parameterService, googleAnalyticsService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loopByTypeTruck && changes.loopByTypeTruck.currentValue) {
      this.handleChartConfig(changes.loopByTypeTruck.currentValue);
    }
  }

  private handleChartConfig(data: IResponseLapExtractionModal): void {
    const shift = this.parameterService.parameters.item('shift').value as IShift;
    if (data) {
      this.dataProductionList = this.setChartConfig(shift, data);
    }
  }

  /**
   * define Chart Properties
   */
  protected defineChartProperties(dataProdList: any): any {
    const categories = dataProdList.lapsByModelAndExtractionList.map((production) => production.extractionPoint);
    const xtext = this.langService.message('street').toUpperCase();
    const ytext = this.langService.message('loops').toUpperCase();
    const series = this.buildSeriesForChart(dataProdList);

    return { categories, xtext, ytext, series };
  }

  protected tooltipModalHtml = (tooltipProps: any): string => {
    let tooltipZoneText = '';
    if (tooltipProps.zoneName !== '') {
      tooltipZoneText = `<span> ${tooltipProps.zoneName} - ${tooltipProps.streetName} - ${tooltipProps.x}</span> <br>`;
    } else {
      tooltipZoneText = `<span> ${tooltipProps.streetName} - ${tooltipProps.x}</span> <br>`;
    }
    return `
          <div style="width: 200px;">
            <strong>${tooltipProps.shiftTooltipLabel}</strong> <br>
            ${tooltipZoneText}
            <div style="margin-top: 2px;">
              <svg width="20" height="13" style="float: left; margin-right: 5px; border-radius: 1px;">
                <rect width="20" height="13" style="fill:${tooltipProps.color.slice(0, -2)};"/>
              </svg>
              <span>${tooltipProps.y} ${
      tooltipProps.y === 0 || tooltipProps.y > 1 ? this.langService.message('loops') : this.langService.message('loop')
    } (${tooltipProps.series.name})</span>
          </div>`;
  };

  /**
   * Function to build series for display chart values
   *
   * @param prodByStreetList data to fill chart view
   */
  protected buildSeriesForChart(prodByTypeTruck: any): any {
    let series = [];
    for (const model of prodByTypeTruck?.lapsMachineModel) {
      const data = prodByTypeTruck.lapsByModelAndExtractionList.map((lap) => {
        const mapped = lap.lapsByExtractionPoint.find((total) => total.machineModelId === model.machineModelId);

        return { y: mapped.laps };
      });
      const serie = {
        name: model.name,
        data,
        color: `${model.colorCode}80`,
        borderColor: model.colorCode,
        borderWidth: 2,
        states: {
          hover: {
            color: model.colorCode,
          },
        },
      };
      series = [...series, serie];
    }
    this.hasData = !!series.length;
    return series;
  }
}
